import React from "react";
import {
  ACTION_TAKEN_OPTIONS,
  ADMIN_SUPERVISE_PICKER_ENTRIES,
  EVENTS_LIMIT,
  GENDER_OPTIONS,
  SUBSCRIPTION_OPTIONS
} from "../../../../constants/picker-entries-constants";
import i18n from "../../../../constants/i18n";
import getRootStore from "../../../../stores/core/root-store";
import getSuperviseStore from "../../../../stores/supervisor-store/supervise-store";
import Et3Button from "../../../../core/et3-button";
import ET3Div from "../../../../core/et3-div";
import { withLiteObserverAndTheme } from "../../../../core/et3-enhanced-render";
import Et3Date from "../../../../core/et3-input/et3-date";
import Et3Margin from "../../../../core/et3-ui/ET3Margin";
import { ISSUES_ARRAY } from "../../../../constants/input-entries-constants";
import Et3Picker from "../../../../core/et3-input/et3-picker";
import { TEt3PickerSingleValue } from "../../../../TypesNEW";

const SuperviseForm = withLiteObserverAndTheme((props) => {
  const { theme } = props;
  const { colors } = theme;
  const allAdmins = getRootStore().allAdmins.get();
  const isEnabled = getSuperviseStore().isGetButtonEnabled.get();

  return (
    <React.Fragment>
      <ET3Div
        isScrollable={false}
        isExtendable={false}
        fDirection="row"
        justifyContent="flex-start"
        alignItems="flex-start"
        withShadow={false}
        width={1200}
        height={75}
        color={colors.all.transparent}
        style={{}}
        onClick={() => {}}
      >
        <Et3Picker
          label={i18n.get("ADMIN")}
          options={allAdmins}
          value={getSuperviseStore().adminInput.get()}
          onChoose={(value: TEt3PickerSingleValue) => {
            getSuperviseStore().setAdmin(value);
          }}
          onEnter={() => {}}
          isMultiple={false}
          style={{}}
          onClick={() => {}}
          containerStyle={{}}
        />
        <Et3Margin top={0} bottom={0} left={0} right={30} />
        <Et3Picker
          label={i18n.get("TYPE")}
          options={ADMIN_SUPERVISE_PICKER_ENTRIES}
          value={getSuperviseStore().typeInputAuditedEvent.get()}
          onChoose={(value: TEt3PickerSingleValue) => {
            getSuperviseStore().setTypeInputAuditedEvent(value);
          }}
          onEnter={() => {}}
          isMultiple={false}
          style={{}}
          onClick={() => {}}
          containerStyle={{}}
        />
        <Et3Margin top={0} bottom={0} left={0} right={30} />
        <Et3Picker
          label={i18n.get("ISSUE_TYPE")}
          options={ISSUES_ARRAY}
          value={getSuperviseStore().typeInputAuditedIssue.get()}
          onChoose={(value: TEt3PickerSingleValue) => {
            getSuperviseStore().typeInputAuditedIssue.set(value);
          }}
          onEnter={() => {}}
          isMultiple={false}
          style={{}}
          onClick={() => {}}
          containerStyle={{}}
        />
        <Et3Margin top={0} bottom={0} left={0} right={30} />
        <Et3Picker
          label={i18n.get("LIMIT")}
          options={EVENTS_LIMIT}
          value={getSuperviseStore().limitInput.get()}
          onChoose={(value: TEt3PickerSingleValue) => {
            getSuperviseStore().setLimitInput(value);
          }}
          onEnter={() => {}}
          isMultiple={false}
          style={{}}
          onClick={() => {}}
          containerStyle={{}}
        />
      </ET3Div>
      <Et3Margin top={15} bottom={0} left={0} right={0} />
      <ET3Div
        isScrollable={false}
        isExtendable={false}
        fDirection="row"
        justifyContent="flex-start"
        alignItems="flex-start"
        withShadow={false}
        width={1200}
        height={75}
        color={colors.all.transparent}
        style={{}}
        onClick={() => {}}
      >
        <Et3Picker
          label={i18n.get("SUBSCRIPTION")}
          options={SUBSCRIPTION_OPTIONS}
          value={getSuperviseStore().subscriptionInput.get()}
          onChoose={(value: TEt3PickerSingleValue) => {
            getSuperviseStore().setSubscriptionInput(value);
          }}
          onEnter={() => {}}
          isMultiple={false}
          style={{}}
          onClick={() => {}}
          containerStyle={{}}
        />
        <Et3Margin top={0} bottom={0} left={0} right={30} />
        <Et3Picker
          label={i18n.get("GENDER")}
          options={GENDER_OPTIONS}
          value={getSuperviseStore().genderInput.get()}
          onChoose={(value: TEt3PickerSingleValue) => {
            getSuperviseStore().setGenderInput(value);
          }}
          onEnter={() => {}}
          isMultiple={false}
          style={{}}
          onClick={() => {}}
          containerStyle={{}}
        />
        <Et3Margin top={0} bottom={0} left={0} right={30} />
        <Et3Picker
          label={i18n.get("ACTION_TAKEN")}
          options={ACTION_TAKEN_OPTIONS}
          value={getSuperviseStore().actionTakenInput.get()}
          onChoose={(value: TEt3PickerSingleValue) => {
            getSuperviseStore().setActionTakenInput(value);
          }}
          onEnter={() => {}}
          isMultiple={false}
          style={{}}
          onClick={() => {}}
          containerStyle={{}}
        />
      </ET3Div>
      <Et3Margin top={15} bottom={0} left={0} right={0} />
      <ET3Div
        isScrollable={false}
        isExtendable={false}
        fDirection="row"
        justifyContent="flex-start"
        alignItems="flex-start"
        withShadow={false}
        width={1200}
        height={75}
        color={colors.all.transparent}
        style={{}}
        onClick={() => {}}
      >
        <Et3Date
          isEnabled={true}
          hasMax={true}
          hasMin={false}
          label={i18n.get("DATE_MIN")}
          dateInputObservable={getSuperviseStore().dateMinInput}
        />
        <Et3Margin top={0} bottom={0} left={0} right={30} />
        <Et3Date
          hasMax={true}
          hasMin={false}
          label={i18n.get("DATE_MAX")}
          dateInputObservable={getSuperviseStore().dateMaxInput}
          isEnabled={true}
        />
      </ET3Div>
      <Et3Margin top={30} bottom={0} left={0} right={0} />
      <Et3Button
        onClick={async () => getSuperviseStore().getAuditedEventsToSupervise()}
        isEnabled={isEnabled}
        size="LARGE"
        text="GET"
        type="GET"
      />
    </React.Fragment>
  );
});
export default SuperviseForm;
